import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { LOGO_URL, NAV_LINKS, BRAND } from "@/data/content";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 bg-white/90 backdrop-blur-xl border-b ${
          scrolled ? "border-navy/10 shadow-[0_2px_20px_rgba(15,31,61,0.06)] py-3" : "border-transparent py-4"
        }`}
      >
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 flex items-center justify-between">
          <a href="#top" data-testid="nav-logo-link" className="flex items-center">
            <img
              src={LOGO_URL}
              alt="Swastik Healthcare"
              className="h-14 lg:h-20 w-auto object-contain"
            />
          </a>

          <nav className="hidden lg:flex items-center gap-10">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                className="link-underline text-xs uppercase tracking-[0.2em] text-navy/70 hover:text-teal transition-colors duration-300"
              >
                {link.label}
              </a>
            ))}
            <a
              href={`tel:${BRAND.phoneMain.replace(/\s/g, "")}`}
              data-testid="nav-call-button"
              className="btn-sheen flex items-center gap-2 bg-navy text-white px-5 py-2.5 text-xs uppercase tracking-[0.2em] hover:bg-teal transition-colors duration-300"
            >
              <Phone size={14} /> Call Now
            </a>
          </nav>

          <button
            data-testid="nav-mobile-toggle"
            aria-label="Toggle menu"
            className="lg:hidden text-navy"
            onClick={() => setOpen(!open)}
          >
            <span data-testid="mobile-menu-toggle" className="sr-only">menu toggle</span>
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            data-testid="mobile-menu"
            className="fixed inset-0 z-40 bg-white flex flex-col items-center justify-center gap-8"
          >
            {NAV_LINKS.map((link, i) => (
              <motion.a
                key={link.href}
                href={link.href}
                data-testid={`mobile-nav-link-${i}`}
                onClick={() => setOpen(false)}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.08 }}
                className="font-display text-3xl text-navy hover:text-teal"
              >
                {link.label}
              </motion.a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
